import { fetchProducts, type Product } from '../api/catalog'

/** Today's calendar date in Europe/Rome as `YYYY-MM-DD` (the server judges validity in the same zone). */
export function todayInRome(): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Rome',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date())
}

/**
 * F-055 (TASK-0309): products a practice can be given today - on sale (`availableOn`), optionally
 * narrowed by department and customer segment. The segment narrowing is a convenience only: the
 * practice's `consumer`/`business` vocabulary differs from the product's `person`/`company`, so the
 * server does not enforce it (products with no restriction are always included by the API).
 */
export function fetchSelectableProducts(departmentId?: number, segment?: string, operatorId?: number): Promise<Product[]> {
  const customerType = segment === 'consumer' ? 'person' : segment === 'business' ? 'company' : undefined
  return fetchProducts({
    pageSize: 200,
    availableOn: todayInRome(),
    isOption: false, // le opzioni si aggiungono a una pratica, non ne sono il prodotto principale
    ...(departmentId !== undefined ? { departmentId } : {}),
    ...(customerType !== undefined ? { customerType } : {}),
    // Operatore scelto: solo i suoi prodotti.
    ...(operatorId !== undefined ? { operatorId } : {}),
  }).then(r => r.items)
}
